import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

function EditPageSectionItem({ pageSectionItem, pageSectionItemUpdate, pageSectionItemDelete }) {
    const [pageSectionItemDetail, setPageSectionItemDetail] = useState({ ...pageSectionItem });
    useEffect(() => {
        setPageSectionItemDetail({ ...pageSectionItem });
    }, [pageSectionItem]);

    const set = (key, value) => setPageSectionItemDetail((prev) => ({ ...prev, [key]: value }));

    return (
        <Box className="col-md-12">
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} className="Delete-3">
                    <TextField fullWidth label="Heading" variant="outlined" value={pageSectionItemDetail.heading ?? ''} onChange={(e) => set('heading', e.target.value)} />
                </Grid>
                <Grid item xs={12} md={6} className="Delete-3">
                    <TextField fullWidth label="Heading (Arabic)" variant="outlined" value={pageSectionItemDetail.heading_ar ?? ''} onChange={(e) => set('heading_ar', e.target.value)} />
                </Grid>
                <Grid item xs={12} md={6} className="Delete-4">
                    <TextField fullWidth multiline rows={4} label="Content" variant="outlined" value={pageSectionItemDetail.content ?? ''} onChange={(e) => set('content', e.target.value)} />
                </Grid>
                <Grid item xs={12} md={6} className="Delete-4">
                    <TextField fullWidth multiline rows={4} label="Content (Arabic)" variant="outlined" value={pageSectionItemDetail.content_ar ?? ''} onChange={(e) => set('content_ar', e.target.value)} />
                </Grid>
                <Grid item xs={12} md={6} className="Delete-5">
                    <Box>
                        <Box component="span" sx={{ display: 'block', mb: 1, fontSize: '0.875rem', color: 'text.secondary' }}>Image</Box>
                        {pageSectionItemDetail.image_url && (
                            <img width={100} height={100} src={pageSectionItemDetail.image_url} alt="" style={{ objectFit: 'cover', borderRadius: 4, marginBottom: 8 }} />
                        )}
                        <input type="file" accept="image/*" onChange={(e) => set('image', e.target.files[0])} className="upload-img" />
                    </Box>
                </Grid>
                <Grid item xs={12} md={6} className="Delete-5">
                    <TextField fullWidth label="Image alt text (SEO)" variant="outlined" placeholder="Describe the image" value={pageSectionItemDetail.image_alt ?? ''} onChange={(e) => set('image_alt', e.target.value)} />
                </Grid>
                <Grid item xs={12}>
                    <Button variant="contained" color="primary" onClick={() => pageSectionItemUpdate(pageSectionItemDetail)} sx={{ mr: 1 }}>Update</Button>
                    <Button variant="outlined" color="error" onClick={() => pageSectionItemDelete(pageSectionItemDetail.id)}>Delete</Button>
                </Grid>
            </Grid>
        </Box>
    );
}

export default EditPageSectionItem;